import { render, staticRenderFns } from "./ShareInChat.vue?vue&type=template&id=8195bbd6&scoped=true"
import script from "./ShareInChat.vue?vue&type=script&lang=js"
export * from "./ShareInChat.vue?vue&type=script&lang=js"
import style0 from "./ShareInChat.vue?vue&type=style&index=0&id=8195bbd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8195bbd6",
  null
  
)

export default component.exports